import { createDate } from 'core/utils/date'

import { type BidStatus, type Bid } from '../domain/Bid'
import { mapBidLoadStop, type RawBidLoadStop } from './bid/BidLoadMapper'

export type RawBidLoad = {
  uuid: string
  mode: string
  ref_number: string
  stops: RawBidLoadStop[]
}

export type RawBidOffer = {
  uuid: string
  price: number
}

export type RawBid = {
  uuid: string
  price: string
  created_at: string
  expires_at: string
  expired_at: Nullable<string>
  status: BidStatus
  source: string
  load: RawBidLoad
  offer: RawBidOffer
  refuse_reason: Nullable<string>
  countered_bid: Nullable<string>
  countered_bid_data: Nullable<RawBid>
}

export function mapApiToBid(rawBid?: Nullable<RawBid>): Bid {
  if (rawBid == null) {
    throw new TypeError(`Expected rawBid, but received "${rawBid === null ? 'null' : 'undefined'}"`)
  }

  const Bid: Bid = {
    uuid: rawBid.uuid,
    price: Number(rawBid.price),
    bookPrice: Number(rawBid.offer?.price),
    createdAt: new Date(rawBid.created_at),
    expiresAt: new Date(rawBid.expires_at),
    expiredAt: createDate(rawBid.expired_at),
    status: rawBid.status,
    source: rawBid.source,
    load: {
      uuid: rawBid.load?.uuid,
      refNumber: rawBid.load?.ref_number,
      stops: rawBid.load?.stops?.map(stop => mapBidLoadStop(stop)),
    },
    offer: {
      uuid: rawBid.offer?.uuid,
      price: Number(rawBid.offer?.price),
    },
    refuseReason: rawBid.refuse_reason,
    counteredBid: rawBid.countered_bid_data ? mapApiToBid(rawBid.countered_bid_data) : undefined,
  }

  return Bid
}
